export default "__VITE_PUBLIC_ASSET__58fe2be8__"